var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.fields),function(label,value){return _c('v-select',{key:value,staticClass:"mb-3",attrs:{"outlined":"","dense":"","value":_vm.selectedNode.settings[value],"item-text":"name","item-value":"name","items":_vm.availableInputFields,"label":label,"clearable":""},on:{"input":(val) => _vm.onUpdate(val, `settings[${value}]`)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }